// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"42e33dab","100":"bc0b3b01","205":"2d0b0755","453":"822bd1c5","551":"4071bc02","629":"79d1a721","842":"dae2f144"}[chunkId] + ".chunk.js";
};